module.exports = __webpack_public_path__ + "static/media/java.ee578cce.png";